import { render, staticRenderFns } from "./OptixPublishToPlatformModal.vue?vue&type=template&id=1ac9579c&scoped=true"
import script from "./OptixPublishToPlatformModal.vue?vue&type=script&lang=js"
export * from "./OptixPublishToPlatformModal.vue?vue&type=script&lang=js"
import style0 from "./OptixPublishToPlatformModal.vue?vue&type=style&index=0&id=1ac9579c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac9579c",
  null
  
)

export default component.exports